import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const usefulLinksApi = createApi({
  reducerPath: 'usefulLinksApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getUsefulLinks: builder.query({
      query: (isEnglish = false) => ({
        url: urls.links(isEnglish),
      }),
    }),
    getUsefulLink: builder.query({
      query: (id) => ({
        url: urls.linkDetail(id),
      }),
    }),
    saveUsefulLink: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: urls.linkDetail(req.id),
            method: 'PUT',
            data: req.body,
          };
        } else {
          return {
            url: urls.links(),
            method: 'POST',
            data: req.body,
          };
        }
      },
    }),
    deleteUsefulLink: builder.mutation({
      query(id) {
        return {
          url: urls.linkDetail(id),
          method: 'DELETE',
        };
      },
    }),
  }),
});

export const {
  useGetUsefulLinksQuery,
  useGetUsefulLinkQuery,
  useSaveUsefulLinkMutation,
  useDeleteUsefulLinkMutation,
} = usefulLinksApi;
